import moment from "moment";

// export default function formAPIModelvaccinations(dataArray) {
//   // Assuming dataArray is an array of objects
//   return dataArray.map(({ 
//     admindate,
//     duedate, 
//     id,
//     isactive,
//     vaccine_cd,
//     vaccinename,
//     documents


//     }) => {
//     return Object.freeze({
//       // admindate: moment(admindate).format("Do MMM YYYY"),
//       // duedate: moment(duedate).format("Do MMM YYYY"), 
//       admindate,
//       duedate,
//       id,
//       isactive,
//       vaccine_cd,
//       vaccinename,
//       documents
      

//     });
//   });
// }

// -------------------------------------------------------------------------

// Updated middleware function to process both vaccinations and vaccination chart
export default function formAPIModelvaccinations(data) {
  return {
    vaccinations: processVaccinationsData(data.vaccinations),
    vaccinationChart: processVaccinationChartData(data.vaccinationchart)
  };
}

// Existing processVaccinationsData function
function processVaccinationsData(vaccinations, visitDate) {
  if (!Array.isArray(vaccinations)) {
    return [];
  }

  const filteredData = visitDate
    ? vaccinations.filter(
        (vaccine) => vaccine.admindate.split("T")[0] === visitDate.split("T")[0]
      )
    : vaccinations;

  const processedData = filteredData.map((vaccine) => {
    let attachmentCounter = 1;
    
    return {
      id: vaccine.id,
      vaccinename: vaccine.vaccinename,
      isactive: vaccine.isactive,
      admindate: vaccine.admindate,
      duedate: vaccine.duedate,
      vaccine_cd: vaccine.vaccine_cd,
      attachments: (vaccine.documents || []).map((document) => {
        const extension = document?.documenturl?.split(".").pop();
        const name = `Vaccine-${attachmentCounter++}.${extension}`;

        return {
          link: document?.imagepath + document?.documenturl,
          name: name,
        };
      }),
    };
  });

  processedData.sort((a, b) => new Date(b.adminDate) - new Date(a.adminDate));
  return processedData;
}

// Enhanced processVaccinationChartData function
function processVaccinationChartData(vaccinationChart) {
  if (!Array.isArray(vaccinationChart)) {
    return [];
  }

  // Filter out null age ranges (like the first item in your example)
  const filteredChart = vaccinationChart.filter(
    (ageGroup) => ageGroup.age_range !== null
  );

  const processedChart = filteredChart.map((ageGroup) => {
    const processedVaccines = ageGroup.vaccines 
      ? ageGroup.vaccines.map((vaccine) => ({
          id: vaccine.id,
          name: vaccine.vaccine_name,
          doseInfo: vaccine.dose_info,
          isMandatory: vaccine.mandatory,
          remarks: vaccine.remarks || '',
          nextDoseDate: vaccine.nextdosagedate,
          ageRange: vaccine.age_range,
          ageInDays: vaccine.age_in_days,
          isActive: true
        }))
      : null;

    return {
      ageRange: ageGroup.age_range,
      ageInDays: ageGroup.age_in_days,
      vaccines: processedVaccines,
      hasVaccines: !!ageGroup.vaccines
    };
  });

  // Sort by age in days (ascending)
  processedChart.sort((a, b) => a.ageInDays - b.ageInDays);
  return processedChart;
}
